import { httpClient, type ID } from '#shared'
import type { EditMessagePayload } from '../model/edit-message-payload'
import type { SendMessageResponse } from '../model/send-message-response'

export async function editMessage(chatId: ID, payload: EditMessagePayload) {
  if (payload.respondFor) {
    payload.respondFor = {
      id: payload.respondFor.id,
    }
  }

  const response = await httpClient.post<SendMessageResponse>(`chats/${chatId}/messages/${payload.id}`, {
    json: payload,
    requireAuth: true,
  })

  const responseBody = await response.json()

  return responseBody
}
